// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__a4mV6","hand":"Home_hand__hWM2e","wave":"Home_wave__JKUPC","resumeButton":"Home_resumeButton__wBaev"};